import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Button, Card, Container, Typography } from '@mui/material';
import { CommunicationIcon, EasyCrmLogo, EasyWebinarLogo, EyepasswordIcon, GroupIcon, LaunchIcon, NotificationIcon, ReloadIcon } from '../../../../assets/icons';
import Grid from '@mui/material/Grid2';
import { addonsImg } from '../../../../assets/images';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import ManageNotification from '../../../modals/ManageNotification';


interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}


function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}


const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 8,
    borderRadius: 18,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: "#DDE0E5",
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 16,
        backgroundColor: '#07CB7399',
    },
}));

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function ManageSubscription({ navigate }: any) {
    const [value, setValue] = React.useState(0);
    const [showCard, setShowCard] = React.useState(false);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const [dialogOpen, setDialogOpen] = React.useState(false);

    const handleDialogOpen = () => {
        setDialogOpen(true);
    };

    const handleDialogClose = () => {
        setDialogOpen(false);
    };

    const handleButtonClick = () => {
        setShowCard(true);
    };


    return (
        <Container sx={{ maxWidth: "1200px", px: '0!important' }}>
            <Box className='tabs-modification'>
                <Box mb={{ xs: "34px", sm: '20px', xl: "34px" }}>
                    <Typography color="#333333" fontSize="24px" mb="15px" fontWeight="500">
                        Subscriptions
                    </Typography>
                    <Typography color='#333333' fontSize='16px'>Manage your subscriptions</Typography>
                </Box>
                <Box sx={{ width: '100%' }}>
                    <Box display='flex' justifyContent='space-between' alignItems='center' flexWrap={{ xs: 'wrap', sm: 'unset' }}>
                        <Tabs value={value} onChange={handleChange} variant="scrollable" scrollButtons="auto">
                            <Tab label="Active" {...a11yProps(0)} sx={{ textTransform: 'capitalize', fontSize: { xs: '14px', sm: '16px' }, padding: { xs: '6px', sm: 'unset' } }} />
                            <Tab label="Expired" {...a11yProps(1)} sx={{ textTransform: 'capitalize', fontSize: { xs: '14px', sm: '16px' }, padding: { xs: '6px', sm: 'unset' } }} />
                            {/* <Tab label="Other Products" {...a11yProps(2)} sx={{ textTransform: 'capitalize', fontSize: { xs: '14px', sm: '16px' }, padding: { xs: '6px', sm: 'unset' } }} /> */}
                        </Tabs>
                        <Box display='flex' alignItems='center' mt={{ xs: '15px', sm: 'unset' }} width={{ xs: '100%', sm: 'unset' }} justifyContent={{ xs: 'flex-end', sm: 'unset' }}>
                            <Typography color='#333333' fontSize='14px' mr='8px' >Manage Notifications</Typography>
                            <Box onClick={handleDialogOpen}
                                sx={{
                                    cursor: "pointer",
                                    height: "36px",
                                    width: "36px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    // padding:"5px",
                                    "&:hover": {
                                        border: "1px solid #178EFC",
                                        borderRadius: "4px",
                                        "& svg": {
                                            "& path": {
                                                fill: "#178EFC",
                                            }

                                        },
                                    },
                                }}
                            ><NotificationIcon ></NotificationIcon></Box>
                            <ManageNotification
                                onClose={handleDialogClose}
                                open={dialogOpen}
                            />
                        </Box>
                    </Box>
                    <CustomTabPanel value={value} index={0}>
                        <Grid container rowSpacing={{ xs: 3, sm: 3, md: 3 }} columnSpacing={{ xs: 3, sm: 2, md: 3 }}>
                            <Grid size={{ xs: 12, sm: 6, md: 6, lg: 4 }}>
                                <Card sx={{ padding: '32px 23px', border: '1px solid #A3A3A3', borderRadius: '8px', boxShadow: '0px 4px 12px 0px rgba(43, 43, 48, 0.08)', display: 'flex', flexDirection: 'column !important', justifyContent: 'center', height: '100%' }}>
                                    <Box display='flex' justifyContent='space-between' flexDirection='column' height='100%'>
                                        <Box textAlign='center'>
                                            <EasyWebinarLogo />
                                            <Box textAlign='center' mt={{ xs: '20px', md: '50px' }} mb='44px'>
                                                <Typography fontWeight='500' color='#333333' fontSize={{ xs: '20px', sm: '24px' }} mb='12px'>Live + Simulive Webinar Plan</Typography>
                                                <Typography color='#333333' fontSize='16px' mb='12px'>Renews on January 24, 2025</Typography>
                                                <Typography color='#666666' fontSize='16px'>500 participants</Typography>
                                            </Box>
                                        </Box>
                                        <Box sx={{ textAlign: 'center' }}>
                                            <Box color='#614EFA' borderRight='8px' mb='12px' fontSize='16px' display='flex' alignItems='center' justifyContent='center' gap='10px' p='8px' sx={{ '&:hover': { bgcolor: '#614EFA12', borderRadius: '8px' } }}>Launch EasyWebinar <LaunchIcon /></Box>
                                            <Button size='large' className='viewDetail-button-wrapper' variant='outlined' fullWidth sx={{
                                                textTransform: 'capitalize', color: '#333333', border: '1px solid #666666', borderRadius: '8px', '&:hover': {
                                                    backgroundColor: '#614EFA',
                                                    color: '#FFFFFF',

                                                }
                                            }} onClick={() => {
                                                navigate('/subscription/1');
                                            }}>View details<Box sx={{ display: 'flex', marginLeft: '10px' }}><EyepasswordIcon /></Box>
                                            </Button>
                                        </Box>

                                    </Box>
                                </Card>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6, md: 6, lg: 4 }}>
                                <Card sx={{ padding: '32px 23px', border: '1px solid #A3A3A3', boxShadow: '0px 4px 12px 0px rgba(43, 43, 48, 0.08)', display: 'flex', flexDirection: 'column !important', justifyContent: 'center', height: '100%', borderRadius: '8px' }}>
                                    <Box display='flex' justifyContent='space-between' flexDirection='column' height='100%'>
                                        <Box textAlign='center'>
                                            <EasyWebinarLogo />
                                            <Box textAlign='center' mt={{ xs: '20px', md: '50px' }} mb='44px'>
                                                <Typography fontWeight='500' color='#333333' fontSize={{ xs: '20px', sm: '24px' }} mb='12px'>Evergreen Webinar Plan</Typography>
                                                <Typography color='#333333' fontSize='16px' mb='12px'>Renews on January 24, 2025</Typography>
                                                <Typography color='#666666' fontSize='16px'>200 participants</Typography>
                                            </Box>
                                        </Box>
                                        <Box sx={{ textAlign: 'center' }}>
                                            <Box color='#614EFA' borderRight='8px' mb='12px' fontSize='16px' display='flex' alignItems='center' justifyContent='center' gap='10px' p='8px' sx={{ '&:hover': { bgcolor: '#614EFA12', borderRadius: '8px' } }}>Launch EasyWebinar <LaunchIcon /></Box>
                                            <Button size='large' className='viewDetail-button-wrapper' variant='outlined' fullWidth sx={{
                                                textTransform: 'capitalize', color: '#333333', border: '1px solid #666666', borderRadius: '8px', '&:hover': {
                                                    backgroundColor: '#614EFA',
                                                    color: '#FFFFFF',

                                                }
                                            }}
                                                onClick={() => {
                                                    navigate('/subscription/1');
                                                }}>View details<Box sx={{ display: 'flex', marginLeft: '10px' }}><EyepasswordIcon /></Box>
                                            </Button>
                                        </Box>

                                    </Box>
                                </Card>
                            </Grid>
                            {/* when click on the start trial button */}
                            {showCard && (
                                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 4 }}>
                                    <Card
                                        sx={{
                                            padding: '32px 23px',
                                            border: '1px solid #A3A3A3',
                                            boxShadow: '0px 4px 12px 0px rgba(43, 43, 48, 0.08)',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            height: '100%',
                                            borderRadius: '8px',
                                        }}
                                    >
                                        <Box display="flex" justifyContent="space-between" flexDirection="column" height="100%">
                                            <Box textAlign="center">
                                                <EasyCrmLogo />
                                                <Box textAlign="center" mt={{ xs: '20px', md: '50px' }} mb="44px">
                                                    <Typography
                                                        sx={{
                                                            fontWeight: 500,
                                                            color: '#333333',
                                                            fontSize: { xs: '20px', sm: '24px' },
                                                            mb: '12px',
                                                        }}
                                                    >
                                                        Growth Plan
                                                    </Typography>
                                                    <Typography color="#333333" fontSize="16px" mb="12px">
                                                        Renews on December 14, 2025
                                                    </Typography>
                                                    <Typography color="#666666" fontSize="16px">
                                                        5 Users
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            <Box sx={{ textAlign: 'center' }}>
                                                <Box
                                                    sx={{
                                                        color: '#614EFA',
                                                        mb: '12px',
                                                        fontSize: '16px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        gap: '10px',
                                                        p: '8px',
                                                        '&:hover': { bgcolor: '#614EFA12', borderRadius: '8px' },
                                                    }}
                                                >
                                                    Launch EasyCRM <LaunchIcon />
                                                </Box>
                                                <Button
                                                    size="large"
                                                    className="viewDetail-button-wrapper"
                                                    variant="outlined"
                                                    fullWidth
                                                    sx={{
                                                        textTransform: 'capitalize',
                                                        color: '#333333',
                                                        border: '1px solid #666666',
                                                        borderRadius: '8px',
                                                        '&:hover': {
                                                            backgroundColor: '#614EFA',
                                                            color: '#FFFFFF',
                                                        },
                                                    }}
                                                    onClick={() => {
                                                        navigate('/subscription/2');
                                                    }}
                                                >
                                                    View details
                                                    <Box sx={{ display: 'flex', marginLeft: '10px' }}>
                                                        <EyepasswordIcon />
                                                    </Box>
                                                </Button>
                                            </Box>
                                        </Box>
                                    </Card>
                                </Grid>
                            )}
                            <Grid size={{ xs: 12, sm: 6, md: 6, lg: 4 }}>
                                <Card sx={{ padding: '32px 23px', border: '1px solid #A3A3A3', boxShadow: '0px 4px 12px 0px rgba(43, 43, 48, 0.08)', display: 'flex', flexDirection: 'column !important', justifyContent: 'center', position: 'relative', height: '100%', borderRadius: '8px' }}>
                                    <Box display='flex' justifyContent='space-between' flexDirection='column' height='100%'>
                                        <Box textAlign='center'>
                                            <Box>
                                                <GroupIcon></GroupIcon>
                                                <Button sx={{
                                                    position: 'absolute', right: '0', borderRadius: "4px 0 0 4px",
                                                    color: '#fff !important', fontSize: '16px', textTransform: 'capitalize', fontWeight: '500', px: '25px', height: '30px', bgcolor: '#A3A3A3', ':hover': {
                                                        boxShadow: 'none !important', cursor: 'unset',
                                                    }
                                                }}>Add Ons</Button>
                                            </Box>
                                            <Box textAlign='center' mt='12px'>
                                                <Typography fontWeight='500' color='#333333' fontSize={{ xs: '20px', sm: '24px' }} mb='12px' maxWidth='258px' margin='auto' lineHeight='32px'>Additional Leads and Live Attendees</Typography>
                                                <Typography color='#333333' fontSize='16px' mb='20px' mt='12px'>Renews on January 24, 2025</Typography>
                                            </Box>
                                            <Box mb='14px'>
                                                <Box mb='20px'>
                                                    <Typography color='#333333' fontSize='12px' mb='4px' textAlign='left'>Additional Leads [210/500]</Typography>
                                                    <BorderLinearProgress variant="determinate" value={70} />
                                                </Box>
                                                <Box mb='20px'>
                                                    <Typography color='#333333' fontSize='12px' mb='4px' textAlign='left'>Additional Live Attendees [110/500]</Typography>
                                                    <BorderLinearProgress variant="determinate" value={30} />
                                                </Box>
                                            </Box>
                                            <Typography color='#22B060' fontSize='34px' fontWeight='500' display='flex' justifyContent='center' alignItems='baseline'>$70/ <Typography fontSize='18px'>month</Typography></Typography>
                                        </Box>
                                    </Box>
                                </Card>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6, md: 6, lg: 4 }}>
                                <Card sx={{ padding: '32px 23px', border: '1px solid #A3A3A3', boxShadow: '0px 4px 12px 0px rgba(43, 43, 48, 0.08)', display: 'flex', flexDirection: 'column !important', justifyContent: 'center', position: 'relative', height: '100%', borderRadius: '8px' }}>
                                    <Box display='flex' justifyContent='space-between' flexDirection='column' height='100%'>
                                        <Box textAlign='center'>
                                            <Box>
                                                <Button sx={{
                                                    position: 'absolute', right: '0', borderRadius: "4px 0 0 4px",
                                                    color: '#fff !important', fontSize: '16px', textTransform: 'capitalize', fontWeight: '500', px: '25px', height: '30px', bgcolor: '#A3A3A3', ':hover': {
                                                        boxShadow: 'none !important', cursor: 'unset',
                                                    }
                                                }}>Add Ons</Button>
                                            </Box>
                                            <Box textAlign='center' mt='34px' mb='61px'>
                                                <CommunicationIcon></CommunicationIcon>
                                                <Typography fontWeight='500' color='#333333' fontSize={{ xs: '20px', sm: '24px' }}>Additional Co Hosts</Typography>
                                                <Typography color='#333333' fontSize='16px' mb='12px'>Renews on January 24, 2025</Typography>
                                                <Typography color='#333333' fontSize='16px'>1 additional Co Host</Typography>
                                            </Box>
                                            <Typography color='#22B060' fontSize='34px' fontWeight='500' display='flex' justifyContent='center' alignItems='baseline'>$78/ <Typography fontSize='18px'>month</Typography></Typography>
                                        </Box>
                                    </Box>
                                </Card>
                            </Grid>
                        </Grid>
                        <Grid container rowSpacing={{ xs: 3, sm: 3, md: 3 }} columnSpacing={{ xs: 3, sm: 2, md: 3 }}>
                            <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                                <Typography color='#333333' fontWeight='500' fontSize='24px' mb='20px' mt={{ xs: '30px', lg: '77px' }}>Explore Other Products</Typography>
                                <Box sx={{ padding: { xs: '23px', lg: '32px' }, boxShadow: '0px 4px 12px 0px rgba(43, 43, 48, 0.08)', bg: '#fff', border: '1px solid #614EFA', borderRadius: '8px' }}
                                >
                                    <Box>
                                        <EasyCrmLogo />
                                        <Typography mb='12px' fontSize='16px' color='#333333' mt='24px'>Improve Your Sales Process & Grow Your Business</Typography>
                                        <Typography mb='20px' fontSize='14px' color='#666666'>EasySuite CRM helps make selling easier! Track your leads from start to finish, identify successful sales strategies, collaborate with your team and access everything from one easy to use platform.</Typography>
                                    </Box>
                                    <Box display='flex' gap='17px'>
                                        <Button variant='outlined' onClick={handleButtonClick} size='large' sx={{
                                            textTransform: 'capitalize', border: '1px solid #614EFA', borderRadius: '8px', color: '#614EFA', "&:hover": {
                                                border: "1px solid #614EFA",
                                            }
                                        }}>Start Trial</Button>
                                        {/* <Button variant='text' size='large' sx={{ textTransform: 'capitalize' }}>View Plans</Button> */}
                                    </Box>
                                </Box>
                                <Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={1}>
                        <Typography color='#333333' fontWeight='500' fontSize='18px' mb='12px'> Plans</Typography>
                        <Grid container rowSpacing={{ xs: 3, sm: 3, md: 3 }} columnSpacing={{ xs: 3, sm: 2, md: 3 }}>
                            <Grid size={{ xs: 12, sm: 6, md: 6, xl: 4 }} maxWidth={{ lg: '364px', xl: 'unset' }}>
                                <Card sx={{ padding: '32px 23px', border: '1px solid #A3A3A3', boxShadow: '0px 4px 12px 0px rgba(43, 43, 48, 0.08)', display: 'flex', flexDirection: 'column !important', justifyContent: 'center', height: '100%', borderRadius: '8px' }}>
                                    <Box display='flex' justifyContent='space-between' flexDirection='column' height='100%'>
                                        <Box textAlign='center'>
                                            <EasyWebinarLogo />
                                            <Box textAlign='center' mt={{ xs: '20px', md: '50px' }} mb={{ xs: '20px', sm: '59px' }}>
                                                <Typography fontWeight='500' color='#333333' fontSize={{ xs: '20px', sm: '24px' }} mb='12px'>Live + Simulive Webinar Plan</Typography>
                                                <Typography color='#666666' fontSize='16px' mb='12px'>500 participants</Typography>
                                                <Typography color='#E44258' fontSize='16px' mb='12px'>Expired on Jun 11</Typography>
                                            </Box>
                                        </Box>
                                        <Button size='large' className='renew-button-wrapper' variant='outlined' fullWidth sx={{
                                            textTransform: 'capitalize', color: '#333333', border: '1px solid #666666', borderRadius: '8px', '&:hover': {
                                                backgroundColor: '#614EFA',
                                                color: '#FFFFFF',

                                            }
                                        }}>Renew Now<Box sx={{ display: 'flex', marginLeft: '10px' }}><ReloadIcon /></Box>
                                        </Button>

                                    </Box>
                                </Card>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6, md: 6, xl: 4 }} maxWidth={{ lg: '364px', xl: 'unset' }}>
                                <Card sx={{ padding: '32px 23px', border: '1px solid #A3A3A3', boxShadow: '0px 4px 12px 0px rgba(43, 43, 48, 0.08)', display: 'flex', flexDirection: 'column !important', justifyContent: 'center', position: 'relative', height: '100%', borderRadius: '8px' }} >
                                    <Box display='flex' justifyContent='space-between' flexDirection='column' height='100%'>
                                        <Box textAlign='center'>
                                            <Box position='absolute' right='0' top='0'>
                                                <img src={addonsImg} />
                                            </Box>
                                            <Box textAlign='center' mt='34px' mb={{ xs: '20px', sm: '59px' }}>
                                                <CommunicationIcon></CommunicationIcon>
                                                <Typography fontWeight='500' color='#333333' fontSize={{ xs: '20px', sm: '24px' }} mb='12px'>Additional Co Hosts</Typography>
                                                <Typography color='#333333' fontSize='16px' mb='12px'>1 additional Co Host</Typography>
                                                <Typography color='#E44258' fontSize='16px' mb='12px'>Expired on Jun 11</Typography>
                                            </Box>
                                            <Button size='large' className='renew-button-wrapper' variant='outlined' fullWidth sx={{
                                                textTransform: 'capitalize', color: '#333333', border: '1px solid #666666', borderRadius: '8px', '&:hover': {
                                                    backgroundColor: '#614EFA',
                                                    color: '#FFFFFF',

                                                }
                                            }}>Renew Now<Box sx={{ display: 'flex', marginLeft: '10px' }}><ReloadIcon /></Box>
                                            </Button>
                                        </Box>
                                    </Box>
                                </Card>
                            </Grid>
                        </Grid>
                        <Grid container rowSpacing={{ xs: 3, sm: 3, md: 3 }} columnSpacing={{ xs: 3, sm: 2, md: 3 }}>
                            <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                                <Typography color='#333333' fontWeight='500' fontSize='24px' mb='20px' mt={{ xs: '30px', lg: '77px' }}>Explore Other Products</Typography>
                                <Box sx={{ padding: { xs: '23px', lg: '32px' }, boxShadow: '0px 4px 12px 0px rgba(43, 43, 48, 0.08)', bg: '#fff', border: '1px solid #614EFA', borderRadius: '8px' }}
                                >
                                    <Box>
                                        <EasyCrmLogo />
                                        <Typography mb='12px' fontSize='16px' color='#333333' mt='24px'>Improve Your Sales Process & Grow Your Business</Typography>
                                        <Typography mb='20px' fontSize='14px' color='#666666'>EasySuite CRM helps make selling easier! Track your leads from start to finish, identify successful sales strategies, collaborate with your team and access everything from one easy to use platform.</Typography>
                                    </Box>
                                    <Box display='flex' gap='17px'>
                                        <Button variant='outlined' size='large' sx={{
                                            textTransform: 'capitalize', border: '1px solid #614EFA', borderRadius: '8px', color: '#614EFA', "&:hover": {
                                                border: "1px solid #614EFA",
                                            }
                                        }}>Start Trial</Button>
                                        {/* <Button variant='text' size='large' sx={{ textTransform: 'capitalize' }}>View Plans</Button> */}
                                    </Box>
                                </Box>
                                <Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </CustomTabPanel>
                </Box >
            </Box>
        </Container >
    );
}
